import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { DeleteModalComponent } from '../bookmark/delete-modal/delete-modal.component';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import WKT from 'ol/format/WKT';
import { Draw, Interaction } from 'ol/interaction';
import { Circle, Fill, Icon, Stroke, Style } from 'ol/style';
import { getCenter } from 'ol/extent';
import { GlobalService } from 'src/app/services/global.service';
import { EditAnnotationRightComponent } from './edit-annotation-right/edit-annotation-right.component';
import { ZoomComponent } from './zoom/zoom.component';

import { HttpClient } from '@angular/common/http';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
import * as CryptoJS from 'crypto-js';
import { LoaderComponent } from 'src/app/modules/shared/components/loader/loader.component';

@Component({
  selector: 'app-annotation',
  templateUrl: './annotation.component.html',
  styleUrls: ['./annotation.component.css'],
})
export class AnnotationComponent implements OnInit, OnDestroy {
  @ViewChild('expPanel1') panel1: any;
  @ViewChild('expPanel2') panel2: any;
  @ViewChild('expPanel3') panel3: any;
  @ViewChild('expPanel4') panel4: any;
  @ViewChild('expPanelFolder') panelFolder: any = [];

  //default selected color
  selectedColor = '#FFA500';
  colorPalette: Array<any> = [
    '#FF0000',
    '#0000FF',
    '#FFFF00',
    '#800080',
    '#00FF00',
    '#FFA500',
  ];

  //for api hit and unit testing
  unitTesting: any;

  panelOpenState1 = false;
  panelOpenState2 = false;
  panelOpenState3 = false;
  panelOpenState4 = false;
  showDeleteButton = false;
  preSelected = false;
  panelOpenState: any = [];

  active: any = [];
  clicked: any = [];
  clickedFolder: any = [];
  deleteArray: any = [];
  singleValue: any = [];

  selectedIndexId: any;
  baseMaps: any;
  previousRes: any;
  boundaries: any;
  previousId: any;
  previousNum: any;
  annotationData: any;
  folderData: any;
  layer: any;
  drawShape: any;
  multiple: any;
  drawLayer: any;
  allowZoom: any;
  enabled: any;
  previousSelection: any;
  data: any;
  state: any;
  state1: any;
  length: any;
  polygonGeometry: any;
  selectedFeatures: any;
  mapId: any;
  layersId: any;
  wkt: any;
  currentZoom: any;
  selectedIndex: any;
  fileUploadData: any;
  change: any;
  html: any;
  previousFolderId: any;
  pre_select_id: any = '';
  decrypted: any;
  keyMes = 'mapId';
  userEn = 'userEncrpto';
  zoomNow: any = true;
  pointGeometry: any = '';
  selectedFeature: any = 'Feature+Selection:+Lasso';
  activityCounter = 0;
  parcelLength = '1';
  slectedUnion = '1';
  ctrlCheck = 'false';
  polygonAnnotation = 'false';
  linesAnnotation = 'false';
  pointSAnnotation = 'false';
  mapResolution = '152.87405654907226';
  closeLeft = '<span><strong>Close</strong><p>Close panel</p></span>';
  myClose = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-close',
  };
  createFolder: any;
  editFolderModal: any;
  folder: any = {
    name: '',
    description: '',
  };

  availableFolder: any;
  clickAvailableFolder: any;
  @ViewChild(LoaderComponent, { static: false }) loader!: LoaderComponent;
  constructor(
    private cd: ChangeDetectorRef,
    public sideNavService: SideNavService,
    public mapService: MapServiceService,
    private dialog: MatDialog,
    private globalService: GlobalService,
    private http: HttpClient
  ) {
    this.mapService.selectedColor = this.selectedColor;
    this.currentZoom = this.mapService.mapLayer.getView().getZoom();

    const element = document.getElementById('map') as HTMLElement;
    element.addEventListener('mouseenter', () => {
      this.hideAvailableFolders();
    });
  }

  ngOnInit(): void {
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.sideNavService.setFeatureNameView = false;
    this.zoomNow = true;
    if (
      !this.mapService.accessMapApi.map_data.map_data.tool_desc['annotator']
    ) {
      this.html = '';
    } else {
      this.html =
        this.mapService.accessMapApi.map_data.map_data.tool_desc['annotator'];
    }
    //select annotation from map component
    this.sideNavService.openZoom.subscribe((res: any) => {
      if (res.folderId) {
        this.sideNavService.setFeatureNameView = true;
        this.zoomClickedForFolder(res.id, -1, res.data, res.folderId);
        this.selectFromMouseFolder(res.id, res.folderId);
      } else {
        this.sideNavService.setFeatureNameView = true;
        this.zoomClicked(res.id, -1, res.data);
        this.selectFromMouse(res.id);
      }
    });

    //clear upload class
    this.sideNavService.clearUploadClass.subscribe(() => {
      this.previousId = null;
      this.active = [];
    });

    //refresh annotation
    this.sideNavService.refreshAnnotation.subscribe((res: any) => {
      this.active = [];
      if (res.id != this.previousRes) {
        if (res.type == 'point') {
          if (!this.panel1.expanded) {
            this.panel1.open();
            this.checkedList(res.type);
          }
        } else if (res.type == 'line') {
          if (!this.panel2.expanded) {
            this.panel2.open();
            this.checkedList(res.type);
          }
        } else if (res.type == 'polygon') {
          if (!this.panel3.expanded) {
            this.panel3.open();
            this.checkedList(res.type);
          }
        } else if (res.type == 'geomcollection') {
          if (!this.panel4.expanded) {
            this.panel4.open();
            this.checkedList(res.type);
          }
        }
        this.previousRes = res.id;
        this.mapService.getdrawEnable(false);
        this.addNewFeature(res);
      }
      this.previousRes = res.id;
    });

    //edit annotation
    this.sideNavService.editAnnotationAfterData.subscribe((res: any) => {
      this.loader.toggleSpinner(true);
      if (res.type == 'editFolder') {
        this.editFolderFeature(res.annotations, res.folderId);
      } else {
        this.editFeature(res.annotations);
      }
    });

    this.sideNavService.uploadAnnotationAfterData.subscribe((res: any) => {
      this.active = [];
      this.addNewFeature(res);
    });

    this.fileUploadData = this.mapService.uploadFileData;
    //delete annotation

    this.sideNavService.deleteAnnotation.subscribe((res: any) => {
      this.loader.toggleSpinner(true);
      this.multiple = false;
      if (res) {
        this.deleteFolderFeature(res);
        this.deleteFeature(res);
        this.deleteArray = [];
        this.showDeleteButton = false;
      }
    });

    this.sideNavService.deleteAnnotationFolder.subscribe((res: any) => {
      for (let i = 0; i < this.sideNavService.folderData.length; i++) {
        if (this.sideNavService.folderData[i].id == res) {
          this.sideNavService.folderData.splice(i, 1);
          this.createFolder = false;
          this.clicked = [];
          this.editFolderModal = false;
          break;
        }
      }
    });

    this.drawLayer = new VectorLayer({
      source: new VectorSource(),
    });

    //get previous state

    this.state = this.sideNavService.annotComponentState;
    this.state1 = this.sideNavService.annotFolderState;

    //get selected layers
    this.layersId = this.mapService.getLayersId();

    //get data from api and maintain state of annotation tool
    this.mapService.mapLayer.addLayer(this.drawLayer);

    if (this.sideNavService.shareAnnot) {
      this.annotationData = this.sideNavService.annotationData;
      this.folderData = this.sideNavService.folderData;
      this.draw();

      if (this.panelOpenState1 == false) {
        this.closePanel1();
      } else {
        this.openPanel1();
      }
      if (this.panelOpenState2 == false) {
        this.closePanel2();
      } else {
        this.openPanel2();
      }
      if (this.panelOpenState3 == false) {
        this.closePanel3();
      } else {
        this.openPanel3();
      }
      if (this.panelOpenState4 == false) {
        this.closePanel4();
      } else {
        this.openPanel4();
      }
      this.sideNavService.shareAnnot = false;
      this.sideNavService.loadFirstTimeAnnot = false;
    }

    if (!this.sideNavService.annotationData) {
      this.decrypted = localStorage.getItem('user') || '';
      if (this.decrypted) {
        const decrypted = CryptoJS.AES.decrypt(this.decrypted, this.userEn);
        const user = decrypted.toString(CryptoJS.enc.Utf8);
        this.data = JSON.parse(user);
      }
      if (this.data || this.unitTesting) {
        this.globalService.toggleLoader(true);
        this.mapService.getAnnotation(this.mapId).subscribe((res) => {
          this.annotationData = res.annotation;
          this.folderData = res.folders;

          this.annotationData = this.sortAnnotationData(
            this.annotationData,
            'name'
          );
          this.folderData = this.sortAnnotationData(this.folderData, 'title');
          this.sideNavService.annotationData = this.annotationData;
          this.sideNavService.folderData = this.folderData;
          this.sideNavService.addAnnotationStateHanledKeys();

          //get previous state
          this.state = this.sideNavService.annotComponentState;
          this.state1 = this.sideNavService.annotFolderState;

          this.draw();

          if (!this.sideNavService.loadFirstTimeAnnot) {
            if (this.panelOpenState1 == false) {
              this.closePanel1();
            } else {
              this.openPanel1();
            }
            if (this.panelOpenState2 == false) {
              this.closePanel2();
            } else {
              this.openPanel2();
            }
            if (this.panelOpenState3 == false) {
              this.closePanel3();
            } else {
              this.openPanel3();
            }
            if (this.panelOpenState4 == false) {
              this.closePanel4();
            } else {
              this.openPanel4();
            }
          } else {
            this.sideNavService.loadFirstTimeAnnot = false;
          }
        });
      }
    } else {
      this.layer = this.sideNavService.annotationLayer;
    }

    //show points from legend tool
    this.sideNavService.legendPoint.subscribe((res: any) => {
      if (res == true) {
        this.showAnnotFromLegend('point');
      } else {
        this.hideAnnotFromLegend('point');
        this.checkUncheckBasedOnLegend('point');
      }
    });

    // show lines from legend
    this.sideNavService.legendLine.subscribe((res: any) => {
      if (res == true) {
        this.showAnnotFromLegend('line');
      } else {
        this.hideAnnotFromLegend('line');
        this.checkUncheckBasedOnLegend('line');
      }
    });

    // show Polygon from legend
    this.sideNavService.legendPolygon.subscribe((res: any) => {
      if (res == true) {
        this.showAnnotFromLegend('polygon');
      } else {
        this.hideAnnotFromLegend('polygon');
        this.checkUncheckBasedOnLegend('polygon');
      }
    });
  }
  sortAnnotationData(arr: any, type: any) {
    //sort annotations inside folders
    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i]?.annotation?.length) {
          arr[i].annotation = this.sortAnnotationInsideFolder(
            arr[i].annotation
          );
        }
      }
      this.manageCurrentFolderStateAfterSort();
      return arr.sort((a: any, b: any) =>
        a[type].toLowerCase() > b[type].toLowerCase() ? 1 : -1
      );
    }
  }

  sortAnnotationInsideFolder(arr: any) {
    return arr.sort((a: any, b: any) =>
      a['name'].toLowerCase() > b['name'].toLowerCase() ? 1 : -1
    );
  }

  manageCurrentFolderStateAfterSort(): void {
    for (let i = 0; i < this.sideNavService.folderData?.length; i++) {
      if (
        !(
          `exapandPanelId${this.sideNavService.folderData[i]?.id}` in
          this.sideNavService.annotFolderState
        )
      ) {
        this.sideNavService.annotFolderState[
          `exapandPanelId${this.sideNavService.folderData[i].id}`
        ] = false;
      }
    }
  }

  //enable class by clicking on specific item
  enableClass(num: any) {
    if (this.previousId == num) {
      this.active[num] = false;
      this.mapService.getdrawEnable(false);
      this.previousId = null;
      this.mapService.mapLayer.removeInteraction(this.drawShape);
    } else {
      this.active = [];
      this.mapService.getdrawEnable(true);
      this.active[num] = true;
      this.previousId = num;
      if (num == 4) {
        this.dialog.open(UploadModalComponent, { disableClose: true });
      }
    }
  }

  //show submenu for specific item
  showMenu(num: any, e: any, id: any): void {
    if (num == -1 && e.target.id.toString() != 'showMenu') {
      this.clicked = [];
      this.previousNum = -1;
      return;
    }
    if (e.target.id.toString() == 'showMenu' && num != -1) {
      if (this.previousNum === num) {
        this.clicked = [];
        this.previousNum = null;
      } else {
        this.singleValue = [id];
        this.clicked = [];
        this.clicked[num] = !this.clicked[num];
        this.previousNum = num;
      }
    }
  }

  //for handling zoom
  zoomClickedEnableZoom(
    value: any,
    j: any,
    data: any,
    folderId: any = null,
    fromFolder: any = null
  ): void {
    this.activityLoging('Zoom+to+Selection');
    if (!fromFolder) {
      this.allowZoom = true;
      this.zoomClicked(value, j, data);
      this.setShareAnnotation();
    } else {
      this.allowZoom = true;
      this.zoomClickedForFolder(value, j, data, folderId);
      this.setShareAnnotationForFolder();
    }
  }

  //function trigger zoom
  zoomClicked(value: any, j: any, data: any): void {
    if (data.subType) {
      delete data.subType;
    }

    //for clearing features after annotation selected in red
    this.mapService.featureLayerId = '';
    if (this.sideNavService.hideRightPanelForImage) {
      this.sideNavService.closeRightSideNav();
      this.sideNavService.hideRightPanelForImage = false;
    }

    this.sideNavService.sideNavState('open');
    //hover deactivate
    this.mapService.stopHover = false;
    this.sideNavService.rightMenuClicked({
      component: ZoomComponent,
      data: data,
      history: false,
      push: true,
    });
    if (this.allowZoom) {
      this.zoomNow = true;
      this.sideNavService.setFeatureNameView = false;
    }
    this.clicked = [];
    const source = this.layer.getSource();
    const features = source.getFeatures();
    this.sideNavService.zoomFeatures = features;

    for (let i = 0; i < features.length; i++) {
      if (features[i].get('id') == value) {
        this.sideNavService.zoomId = value;
        if (j != -1) {
          this.sideNavService.annotationData[j].visible = true;
        }

        if (!this.sideNavService.setFeatureNameView) {
          this.mapService.mapLayer
            .getView()
            .setCenter(getCenter(features[i].getGeometry().getExtent()));
        }

        if (features[i].get('type') == 'point') {
          this.sideNavService.legendAnnotCheck.checked1 = true;

          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            new Style({
              image: new Icon({
                src: '/assets/img/marker_resize.png',
                imgSize: [80, 150],
                offset: [-20, -37],
                scale: 1.0,
                opacity: 1.0,
              }),
            })
          );
        } else if (features[i].get('type') == 'line') {
          this.sideNavService.legendAnnotCheck.checked2 = true;
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            new Style({
              stroke: new Stroke({
                color: 'red',
                width: 5,
              }),
            })
          );
        } else if (features[i].get('type') == 'polygon') {
          this.sideNavService.legendAnnotCheck.checked3 = true;
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            new Style({
              stroke: new Stroke({
                color: 'red',
                width: 5,
              }),
            })
          );
        } else if (features[i].get('type') == 'geomcollection') {
          features[i].setStyle(this.geomcollectionStyleZoom());
        }
        if (!this.sideNavService.setFeatureNameView && this.zoomNow) {
          this.mapService.mapLayer
            .getView()
            .fit(features[i].getGeometry().getExtent(), { maxZoom: 19 });
        }
      }
    }
    this.zoomNow = true;
    this.sideNavService.setFeatureNameView = false;
    this.allowZoom = false;
    this.setShareAnnotation();
  }

  zoomClickedForFolder(
    value: any,
    j: any,
    data: any,
    folderId: any = null
  ): void {
    data.subType = 'folderType';
    data.folderId = folderId;

    //for clearing features after annotation selected in red
    this.mapService.featureLayerId = '';
    if (this.sideNavService.hideRightPanelForImage) {
      this.sideNavService.closeRightSideNav();
      this.sideNavService.hideRightPanelForImage = false;
    }

    this.sideNavService.sideNavState('open');
    //hover deactivate
    this.mapService.stopHover = false;
    this.sideNavService.rightMenuClicked({
      component: ZoomComponent,
      data: data,
      history: false,
      push: true,
    });
    if (this.allowZoom) {
      this.zoomNow = true;
      this.sideNavService.setFeatureNameView = false;
    }
    this.clicked = [];
    const source = this.layer.getSource();
    const features = source.getFeatures();
    this.sideNavService.zoomFeatures = features;

    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('id') == value &&
        features[i].get('subType') == 'folder'
      ) {
        this.sideNavService.zoomId = value;
        if (j != -1) {
          for (let l = 0; l < this.sideNavService.folderData.length; l++) {
            for (
              let j = 0;
              j < this.sideNavService.folderData[l].annotation.length;
              j++
            ) {
              if (this.sideNavService.folderData[l].annotation[j].id == value) {
                this.sideNavService.folderData[l].annotation[j].visible = true;
                break;
              }
            }
          }
        }

        if (!this.sideNavService.setFeatureNameView) {
          this.mapService.mapLayer
            .getView()
            .setCenter(getCenter(features[i].getGeometry().getExtent()));
        }

        if (features[i].get('type1') == 'point') {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            new Style({
              image: new Icon({
                src: '/assets/img/marker_resize.png',
                imgSize: [80, 150],
                offset: [-20, -37],
                scale: 1.0,
                opacity: 1.0,
              }),
            })
          );
        } else if (features[i].get('type1') == 'line') {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            new Style({
              stroke: new Stroke({
                color: 'red',
                width: 5,
              }),
            })
          );
        } else if (features[i].get('type1') == 'polygon') {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            new Style({
              stroke: new Stroke({
                color: 'red',
                width: 5,
              }),
            })
          );
        } else if (features[i].get('type1') == 'geomcollection') {
          features[i].setStyle(this.geomcollectionStyleZoom());
        }
        if (!this.sideNavService.setFeatureNameView && this.zoomNow) {
          this.mapService.mapLayer
            .getView()
            .fit(features[i].getGeometry().getExtent(), { maxZoom: 19 });
        }

        this.zoomNow = true;
        this.sideNavService.setFeatureNameView = false;
        this.allowZoom = false;
        this.setShareAnnotationForFolder();
      }
    }
  }

  //edit point line polygon or upload etc
  edit(id: any, name: any, desc: any, color: any, userFildes: any) {
    const attributeData = JSON.parse(userFildes);
    this.sideNavService.annotationType = 'edit';
    const data = {
      annotation_id: id,
      map_id: this.mapId,
      name: name,
      description: desc,
      annotation_color: color,
      attributeData: attributeData
    };
    this.sideNavService.sideNavState('open');
    //hover deactivate
    this.mapService.stopHover = false;
    this.sideNavService.rightMenuClicked({
      component: EditAnnotationRightComponent,
      data: data,
      history: false,
      push: false,
    });
    this.clicked = [];
    this.setShareAnnotation();
  }

  editFolderBeforeRes(
    id: any,
    name: any,
    desc: any,
    folderId: any,
    color: any
  ) {
    this.sideNavService.annotationType = 'editFolder';

    const data = {
      annotation_id: id,
      map_id: this.mapId,
      name: name,
      description: desc,
      folderId: folderId,
      annotation_color: color,
    };
    this.sideNavService.sideNavState('open');
    //hover deactivate
    this.mapService.stopHover = false;
    this.sideNavService.rightMenuClicked({
      component: EditAnnotationRightComponent,
      data: data,
      history: false,
      push: false,
    });
    this.clicked = [];
    this.setShareAnnotationForFolder();
  }

  //delete or multidelete annotation
  delete(): void {
    // if (this.deleteArray.length == 0) {
    //   this.deleteArray.push(annotationId);
    // }

    this.deleteArray = this.deleteArray.filter(
      (v: any, i: any) => this.deleteArray.indexOf(v) == i
    );

    this.dialog.open(DeleteModalComponent, {
      data: {
        type: 'delete',
        id: this.deleteArray.length ? this.deleteArray : this.singleValue,
      },
    });

    const element: any = document.getElementById(`subMenu${4}`) as HTMLElement;

    const element1 = document.getElementById(
      `delete_modal_folder_position`
    ) as HTMLElement;
    if (element) {
      let topPos = element.getBoundingClientRect().top + window.scrollY;
      if (window.innerHeight - topPos < 100) {
        topPos = topPos - 50;
        element1.style.top = `${topPos.toString()}px`;
      } else {
        topPos = topPos - 10;
        element1.style.top = `${topPos.toString()}px`;
      }
    }

    this.multiple = false;
    // this.clicked = [];
    // this.deleteArray = [];
    this.setShareAnnotation();
  }

 //select specific annotation
 select(value: any, index: any, data: any): void {
  this.pre_select_id = value;
  for (let i = 0; i < this.sideNavService.annotationData.length; i++) {
    if (data.id == this.sideNavService.annotationData[i].id) {
      this.sideNavService.annotationData[i].visible = true;
      if (this.sideNavService.annotationData[i].type == 'point') {
        this.sideNavService.legendAnnotCheck.checked1 = true;
        this.showData(value, data)
        break;
      }
      if (this.sideNavService.annotationData[i].type == 'line') {
        this.sideNavService.legendAnnotCheck.checked2 = true;
        this.showData(value, data)
        break;
      }
      if (this.sideNavService.annotationData[i].type == 'polygon') {
        this.sideNavService.legendAnnotCheck.checked3 = true;
        this.showData(value, data)
        break;
      }
      if (this.sideNavService.annotationData[i].type == 'geomcollection') {
        this.zoomClicked(value, index, data)
        break;
      }
    }
  }

}

showData(value: any, data: any) {
  this.sideNavService.sideNavState('open');
  //hover deactivate
  this.mapService.stopHover = false;
  this.sideNavService.rightMenuClicked({
    component: ZoomComponent,
    data: data,
    history: false,
    push: true,
  });

  this.globalService.toggleLoader(true);

  this.clicked = [];
  const source = this.layer.getSource();
  const features = source.getFeatures();
  for (let i = 0; i < features.length; i++) {
    if (features[i].get('id') == value) {
      const geom = features[i].getGeometry();
      const wkt = new WKT();
      this.wkt = wkt.writeGeometry(geom);
      this.mapService.mapLayer
        .getView()
        .setCenter(getCenter(features[i].getGeometry().getExtent()));

      this.mapService.mapLayer
        .getView()
        .fit(features[i].getGeometry().getExtent(), { maxZoom: 19 });
      this.currentZoom = this.mapService.mapLayer.getView().getZoom();
      this.mapService.setCurrentZoom(this.currentZoom);
      this.layersId = this.mapService.getLayersId();

      if (features[i].get('type') == 'point') {
        features[i].setStyle(this.pointStyle(features[i].get('color')));
        this.activityLogingWkt('point: zoom To Selection', this.wkt);
      } else if (features[i].get('type') == 'line') {
        features[i].setStyle(this.lineStyle(features[i].get('color')));
        this.activityLogingWkt('line: zoom To Selection', this.wkt);
      } else if (features[i].get('type') == 'polygon') {
        features[i].setStyle(this.polygonStyle(features[i].get('color')));
        this.activityLogingWkt('polygon: zoom To Selection', this.wkt);
      } else if (features[i].get('type') == 'geomcollection') {
        features[i].setStyle(
          this.geomcollectionStyle(features[i].get('color'))
        );
        this.activityLogingWkt('geomcollection: zoom To Selection', this.wkt);
      }
    }
  }
  this.getAdvanceSelect();
  this.setShareAnnotation();
}

  selectFolderAnnotation(value: any, data: any): void {
    this.pre_select_id = value;

    this.sideNavService.sideNavState('open');
    //hover deactivate
    this.mapService.stopHover = false;
    this.sideNavService.rightMenuClicked({
      component: ZoomComponent,
      data: data,
      history: false,
      push: true,
    });

    for (let i = 0; i < this.sideNavService.folderData.length; i++) {
      for (
        let j = 0;
        j < this.sideNavService.folderData[i].annotation.length;
        j++
      ) {
        if (this.sideNavService.folderData[i].annotation[j].id == value) {
          this.sideNavService.folderData[i].annotation[j].visible = true;
        }
      }
    }

    this.globalService.toggleLoader(true);
    this.clicked = [];
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('id') == value &&
        features[i].get('subType') == 'folder'
      ) {
        const geom = features[i].getGeometry();
        const wkt = new WKT();
        this.wkt = wkt.writeGeometry(geom);
        this.mapService.mapLayer
          .getView()
          .setCenter(getCenter(features[i].getGeometry().getExtent()));

        this.mapService.mapLayer
          .getView()
          .fit(features[i].getGeometry().getExtent(), { maxZoom: 19 });
        this.currentZoom = this.mapService.mapLayer.getView().getZoom();
        this.mapService.setCurrentZoom(this.currentZoom);
        this.layersId = this.mapService.getLayersId();

        switch (features[i].get('type1')) {
          case 'point':
            features[i].setStyle(this.pointStyle(features[i].get('color')));
            break;
          case 'line':
            features[i].setStyle(this.lineStyle(features[i].get('color')));
            break;
          case 'polygon':
            features[i].setStyle(this.polygonStyle(features[i].get('color')));
            break;
          case 'geomcollection':
            features[i].setStyle(
              this.geomcollectionStyle(features[i].get('color'))
            );
            break;
        }

        // this.activityLog(
        //   features[i].get('type1') + ': zoom To Selection',
        //   this.wkt
        // );
      }
    }
    this.getAdvanceSelect();
    this.setShareAnnotationForFolder();
  }

  //handle state for panel1 opening
  openPanel1(): void {
    this.panelOpenState1 = true;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('type') == 'point' &&
          features[i].get('visible') == true
        ) {
          features[i].setStyle(this.pointStyle(features[i].get('color')));
          features[i].set('visible1', true);
        }
      }
      this.sideNavService.legendAnnotCheck.checked1 = true;

      this.checKAllValues('point');
      this.setState();
      this.activityCounter = this.activityCounter + 1;
      if (this.activityCounter > 1) {
        this.activityLoging('Point:On');
      }
    }
  }

  //handle state for panel1 closing
  closePanel1(): void {
    this.panelOpenState1 = false;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (features[i].get('type') == 'point') {
          features[i].setStyle(new Style({}));
          features[i].set('visible1', false);
        }
      }
      this.sideNavService.legendAnnotCheck.checked1 = false;
      this.checKAllValues('point');
      this.setState();
      this.activityLoging('Point:Off');
    }
  }

  //handle state for panel2 opening
  openPanel2(): void {
    this.panelOpenState2 = true;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('type') == 'line' &&
          features[i].get('visible') == true
        ) {
          features[i].setStyle(this.lineStyle(features[i].get('color')));
          features[i].set('visible1', true);
        }
      }
      this.sideNavService.legendAnnotCheck.checked2 = true;

      this.checKAllValues('line');
      this.setState();
      if (this.activityCounter > 1) {
        this.activityLoging('Line:On');
      }
    }
  }

  //handle state for panel2 closing
  closePanel2(): void {
    this.panelOpenState2 = false;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (features[i].get('type') == 'line') {
          features[i].setStyle(new Style({}));
          features[i].set('visible1', false);
        }
      }
      this.sideNavService.legendAnnotCheck.checked2 = false;

      this.checKAllValues('line');
      this.setState();
      this.activityLoging('Line:Off');
    }
  }

  //handle state for panel3 opening
  openPanel3(): void {
    this.panelOpenState3 = true;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('type') == 'polygon' &&
          features[i].get('visible') == true
        ) {
          features[i].setStyle(this.polygonStyle(features[i].get('color')));
          features[i].set('visible1', true);
        }
      }
      this.sideNavService.legendAnnotCheck.checked3 = true;

      this.checKAllValues('polygon');
      this.setState();
      if (this.activityCounter > 1) {
        this.activityLoging('Polygon:On');
      }
    }
  }

  //handle state for panel3 closing
  closePanel3(): void {
    this.panelOpenState3 = false;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (features[i].get('type') == 'polygon') {
          features[i].setStyle(new Style({}));
          //added later by me
          features[i].set('visible1', false);
        }
      }
      this.sideNavService.legendAnnotCheck.checked3 = false;

      this.checKAllValues('polygon');
      this.setState();
      this.activityLoging('Polygon:Off');
    }
  }

  //handle state for panel4 opening
  openPanel4(): void {
    this.panelOpenState4 = true;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('type') == 'geomcollection' &&
          features[i].get('visible') == true
        ) {
          features[i].set('visible1', true);
          features[i].setStyle(
            this.geomcollectionStyle(features[i].get('color'))
          );
        }
      }

      this.setState();
      if (this.activityCounter > 1) {
        this.activityLoging('Geomcollection:On');
      }
    }
  }

  //handle state for panel4 closing
  closePanel4(): void {
    this.panelOpenState4 = false;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (features[i].get('type') == 'geomcollection') {
          features[i].set('visible1', false);
          features[i].setStyle(new Style({}));
        }
      }
      this.setState();
      this.activityLoging('Geomcollection:Off');
    }
  }

  //function that return point style for annotation
  pointStyle(color: any) {
    color = color.toUpperCase();
    let url: any;
    switch (color) {
      //red
      case '#FF0000':
        url = '/assets/img/tools/annotation_point1_red.png';
        break;
      //blue
      case '#0000FF':
        url = '/assets/img/tools/annotation_point1_blue.png';
        break;
      //Yellow
      case '#FFFF00':
        url = '/assets/img/tools/annotation_point1_yellow.png';
        break;
      //Purple
      case '#800080':
        url = '/assets/img/tools/annotation_point1_purple.png';
        break;
      //Green
      case '#00FF00':
        url = '/assets/img/tools/annotation_point1_green.png';
        break;
      //orange
      default:
        url = '/assets/img/tools/annotation_point1_orange.png';
    }
    return new Style({
      image: new Icon({
        //annotation_point1 is a resize image of original image
        src: url,
        imgSize: [80, 150],
        offset: [-20, -37],
        scale: 1.0,
        opacity: 1.0,
      }),
    });
  }

  //function that return line style for annotation
  lineStyle(color: any) {
    color = color.toUpperCase();
    return new Style({
      fill: new Fill({
        color: color,
      }),
      stroke: new Stroke({
        color: color,
        width: 4,
      }),
    });
  }

  //function that return polygon style for annotation
  polygonStyle(color: any) {
    color = color.toUpperCase();
    return new Style({
      // fill: new Fill({
      //   color: 'rgb(204, 229, 236 , 0.3)',
      // }),
      stroke: new Stroke({
        color: color,
        width: 4,
      }),
    });
  }

  //function that return geomcollection style for annotation
  geomcollectionStyle(color: any) {
    color = color.toUpperCase();
    let url: any;
    switch (color) {
      //red
      case '#FF0000':
        url = '/assets/img/tools/annotation_point1_red.png';
        break;
      //blue
      case '#0000FF':
        url = '/assets/img/tools/annotation_point1_blue.png';
        break;
      //Yellow
      case '#FFFF00':
        url = '/assets/img/tools/annotation_point1_yellow.png';
        break;
      //Purple
      case '#800080':
        url = '/assets/img/tools/annotation_point1_purple.png';
        break;
      //Green
      case '#00FF00':
        url = '/assets/img/tools/annotation_point1_green.png';
        break;

      //Orange
      case '#FFA500':
        url = '/assets/img/tools/annotation_point1_orange.png';
        break;
      default:
      // code block
    }
    return new Style({
      //color modify
      stroke: new Stroke({
        color: color,
        width: 5,
      }),
      image: new Icon({
        src: url,
        imgSize: [80, 150],
        offset: [-20, -37],
        scale: 1.0,
        opacity: 1.0,
      }),
    });
  }

  geomcollectionStyleZoom() {
    return new Style({
      //color modify
      stroke: new Stroke({
        color: 'red',
        width: 5,
      }),
      image: new Icon({
        src: '/assets/img/marker_resize.png',
        imgSize: [80, 150],
        offset: [-20, -37],
        scale: 1.0,
        opacity: 1.0,
      }),
    });
  }

  //checked or unchecked annotation item
  onChange(e: any): void {
    if (e.target.checked == true) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('id') == e.target.value &&
          features[i].get('type') == 'point'
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(this.pointStyle(features[i].get('color')));
          this.checKAllValues('point');
        } else if (
          features[i].get('id') == e.target.value &&
          features[i].get('type') == 'line'
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(this.lineStyle(features[i].get('color')));
          this.checKAllValues('line');
        } else if (
          features[i].get('id') == e.target.value &&
          features[i].get('type') == 'polygon'
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(this.polygonStyle(features[i].get('color')));
          this.checKAllValues('polygon');
        } else if (
          features[i].get('id') == e.target.value &&
          features[i].get('type') == 'geomcollection'
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            this.geomcollectionStyle(features[i].get('color'))
          );
          this.checKAllValues('geomcollection');
        }
      }
    } else {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (features[i].get('id') == e.target.value) {
          features[i].setStyle(new Style({}));
          features[i].set('visible', false);
          features[i].set('visible1', false);

          this.checKAllValues(features[i].get('type'));
        }
      }
    }
    this.setShareAnnotation();
  }

  onChangeFolderAnno(e: any, folderId: any) {
    if (e.target.checked == true) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('id') == e.target.value &&
          features[i].get('type1') == 'point' &&
          features[i].get('folderId') == folderId
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(this.pointStyle(features[i].get('color')));
        } else if (
          features[i].get('id') == e.target.value &&
          features[i].get('type1') == 'line'
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(this.lineStyle(features[i].get('color')));
        } else if (
          features[i].get('id') == e.target.value &&
          features[i].get('type1') == 'polygon'
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(this.polygonStyle(features[i].get('color')));
        } else if (
          features[i].get('id') == e.target.value &&
          features[i].get('type1') == 'geomcollection'
        ) {
          features[i].set('visible', true);
          features[i].set('visible1', true);
          features[i].setStyle(
            this.geomcollectionStyle(features[i].get('color'))
          );
        }
      }
    } else {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('id') == e.target.value &&
          features[i].get('folderId') == folderId
        ) {
          features[i].setStyle(new Style({}));
          features[i].set('visible', false);
          features[i].set('visible1', false);
        }
      }
    }
    this.setShareAnnotationForFolder();
  }
  //function triggers after getting data from api to draw but hide annotation
  draw() {
    this.globalService.toggleLoader(true);
    let feature;
    const vectorSource = new VectorSource();
    const vector = new VectorLayer({
      source: vectorSource,
      zIndex: 101,
    });
    this.layer = vector;
    this.layer.set('name', 'annotation');
    this.sideNavService.annotationLayer = this.layer;
    for (let i = 0; i < this.annotationData?.length; i++) {
      // eslint-disable-next-line no-prototype-builtins
      if (!this.sideNavService.annotationData[i].hasOwnProperty('visible')) {
        this.sideNavService.annotationData[i].visible = true;
      }
      const f = this.annotationData[i];
      const type = f.type;
      const format = new WKT();
      feature = format.readFeature(f[type]);
      feature.set('id', this.annotationData[i].id);
      feature.set('data', this.annotationData[i]);
      feature.set('type', this.annotationData[i].type);
      feature.set('fromTool', 'annotation');
      feature.set('color', this.annotationData[i].annotation_color);
      feature.set('visible', true);
      const style = new Style({});
      feature.setStyle(style);
      vectorSource.addFeatures([feature]);
      this.mapService.annotationFeature = vectorSource;
    }
    for (let i = 0; i < this.sideNavService.folderData?.length; i++) {
      // eslint-disable-next-line no-prototype-builtins

      for (
        let j = 0;
        j < this.sideNavService.folderData[i]?.annotation.length;
        j++
      ) {
        // eslint-disable-next-line no-prototype-builtins
        if (
          !this.sideNavService.folderData[i]?.annotation[j]
            // eslint-disable-next-line no-prototype-builtins
            .hasOwnProperty('visible')
        ) {
          this.sideNavService.folderData[i].annotation[j].visible = true;
          const f = this.sideNavService.folderData[i].annotation[j];
          const type = f.type;
          const format = new WKT();
          feature = format.readFeature(f[type]);
          feature.set('id', this.sideNavService.folderData[i].annotation[j].id);
          feature.set('data', this.sideNavService.folderData[i].annotation[j]);
          feature.set(
            'type1',
            this.sideNavService.folderData[i].annotation[j].type
          );
          feature.set('subType', 'folder');
          feature.set('folderId', this.sideNavService.folderData[i].id);
          feature.set('fromTool', 'annotation');
          feature.set('visible', true);
          feature.set(
            'color',
            this.sideNavService.folderData[i].annotation[j].annotation_color
          );
          const style = new Style({});
          feature.setStyle(style);
          vectorSource.addFeatures([feature]);
          this.mapService.annotationFeature = vectorSource;
        }
      }
    }

    this.mapService.mapLayer.addLayer(vector);
    this.globalService.toggleLoader(false);
  }

  //to draw point line polygon from mouse
  drawShapes(value: any, num: any): void {
    this.mapService.annotationDrawLabel = `${'Save:'}+${value}+ ${'Annotation'}`;
    //hover deactivate
    if (this.sideNavService.hideRightPanelForImage) {
      this.sideNavService.closeRightSideNav();
      this.sideNavService.showAnimateNow = false;
      this.sideNavService.hideRightPanelForImage = false;
    }
    this.mapService.stopHover = false;
    this.mapService.mapLayer.removeInteraction(this.drawShape);
    const source1 = this.drawLayer.getSource();
    const features = source1.getFeatures();
    features.forEach((feature: any) => {
      source1.removeFeature(feature);
    });
    this.drawLayer.setZIndex(101);
    // this.sideNavService.closeRightSideNav();
    if (num != this.previousSelection) {
      this.drawShape = new Draw({
        source: this.drawLayer.getSource(),
        type: value,
        //blue point custom style
        style: new Style({
          image: new Circle({
            radius: 6,
            fill: new Fill({
              color: 'rgb(238, 153, 0 , 0.2)',
            }),
            stroke: new Stroke({
              color: this.selectedColor,
              width: 2,
            }),
          }),
        }),
      });

      const source = this.drawLayer.getSource();
      this.sideNavService.DrawlayerAnnot = this.drawLayer;
      this.drawShape.on('drawstart', (event: any) => {
        const features = source.getFeatures();
        features.forEach((feature: any) => {
          source.removeFeature(feature);
        });

        const polystyle = new Style({
          stroke: new Stroke({
            color: this.selectedColor,
            width: 4,
          }),
        });
        const linestyle = new Style({
          stroke: new Stroke({
            color: this.selectedColor,
            width: 4,
          }),
        });

        value == 'Polygon'
          ? event.feature.setStyle(polystyle)
          : event.feature.setStyle(linestyle);

        if (value == 'Point') {
          const s = new Style({
            image: new Icon({
              src: '/assets/img/anotation-marker.png',
              imgSize: [80, 150],
              offset: [-30, -45],
              scale: 1.0,
              opacity: 1.0,
            }),
          });
          event.feature.setStyle(s);
          event.feature.set('visible', false);
        }
      });

      this.drawShape.on('drawend', (e: any, sidenav = this.sideNavService) => {
        //polygon after drawn
        if (value === 'Polygon') {
          const polystyle1 = new Style({
            // fill: new Fill({
            //   color: 'rgb(204, 229, 236 , 0.3)',
            // }),
            stroke: new Stroke({
              color: this.selectedColor,
              width: 4,
            }),
          });
          e.feature.setStyle(polystyle1);
        }

        const format = new WKT();
        const wkt = format.writeGeometry(e.feature.getGeometry());
        if (value == 'LineString') {
          value = 'line';
        }
        const data = {
          geometry: wkt,
          type: value.toLowerCase(),
          map_id: this.mapId,
          name: '',
          description: '',
          annotation_color: this.selectedColor,
        };
        this.sideNavService.annotationType = 'create';
        this.sideNavService.sideNavState('open');
        //to destroy feature list features
        this.sideNavService.newAnnoCreated = true;
        sidenav.rightMenuClicked({
          component: EditAnnotationRightComponent,
          data: data,
          history: false,
          push: false,
        });
      });

      this.mapService.mapLayer.addInteraction(this.drawShape);
      this.previousSelection = num;
    } else {
      const source = this.drawLayer.getSource();
      const features = source.getFeatures();
      features.forEach((feature: any) => {
        source.removeFeature(feature);
      });
      this.previousSelection = null;
      this.sideNavService.closeRightSideNav();
    }
  }

  deleteFolderFeature(res: any) {
    const source = this.layer.getSource();
    const features = source.getFeatures();

    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('id') == res.id &&
        features[i].get('subType') == 'folder'
      ) {
        features[i].setStyle(new Style({}));
        features[i].set('visible', false);
        source.removeFeature(features[i]);
      }
    }
    for (let i = 0; i < this.sideNavService.folderData.length; i++) {
      for (
        let j = 0;
        j < this.sideNavService.folderData[i].annotation.length;
        j++
      ) {
        if (this.sideNavService.folderData[i].annotation[j].id == res.id) {
          this.sideNavService.folderData[i].annotation[j].visible = false;
          this.sideNavService.folderData[i].annotation.splice(j, 1);
          this.folderData = this.sideNavService.folderData;
        }
      }
    }
    this.loader.toggleSpinner(false);
  }

  //to delete annotation feature after api response
  deleteFeature(res: any) {
    const source = this.layer.getSource();
    const features = source.getFeatures();

    for (let i = 0; i < features.length; i++) {
      if (features[i].get('id') == res.id) {
        features[i].setStyle(new Style({}));
        features[i].set('visible', false);
        source.removeFeature(features[i]);
      }
    }
    for (let i = 0; i < this.sideNavService.annotationData.length; i++) {
      if (this.sideNavService.annotationData[i].id == res.id) {
        this.sideNavService.annotationData[i].visible = false;
        this.sideNavService.annotationData.splice(i, 1);
        this.annotationData = this.sideNavService.annotationData;
      }
    }
    this.loader.toggleSpinner(false);
    this.checKAllValues(res.type);
  }

  //edit feature after api response
  editFeature(res: any): void {
    for (let i = 0; i < this.sideNavService.annotationData.length; i++) {
      if (res.id == this.sideNavService.annotationData[i].id) {
        this.sideNavService.annotationData[i].name = res.name;
        this.sideNavService.annotationData[i].description = res.description;
        this.sideNavService.annotationData[i].user_fields = res.user_fields
        this.sideNavService.annotationData = this.sortAnnotationData(
          this.sideNavService.annotationData,
          'name'
        );
        this.annotationData = this.sideNavService.annotationData;
        break;
      }
    }
    this.loader.toggleSpinner(false);
  }

  editFolderFeature(res: any, folderID: any): void {
    for (let i = 0; i < this.sideNavService.folderData.length; i++) {
      if (this.sideNavService.folderData[i].id == folderID)
        for (
          let j = 0;
          j < this.sideNavService.folderData[i].annotation.length;
          j++
        ) {
          if (this.sideNavService.folderData[i].annotation[j].id == res.id) {
            this.sideNavService.folderData[i].annotation[j].id == res.id;
            this.sideNavService.folderData[i].annotation[j].name = res.name;
            this.sideNavService.folderData[i].annotation[j].description =
              res.description;
            this.sideNavService.folderData = this.sortAnnotationData(
              this.sideNavService.folderData,
              'title'
            );
            this.folderData = this.sideNavService.folderData;
            break;
          }
        }
    }
    this.loader.toggleSpinner(false);
  }

  //add new feature after api response
  addNewFeature(res: any): void {
    this.previousSelection = null;
    this.mapService.mapLayer.removeInteraction(this.drawShape);
    const source = this.drawLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      source.removeFeature(feature);
    });
    let feature: any = null;
    if (!this.sideNavService.annotationData.includes(res)) {
      res.visible = true;
      this.sideNavService.annotationData.push(res);
      this.sideNavService.annotationData = this.sortAnnotationData(
        this.sideNavService.annotationData,
        'name'
      );
      this.annotationData = this.sideNavService.annotationData;

      const f = res;
      const type = f.type;
      const format = new WKT();
      feature = format.readFeature(f[type]);
      feature.set('id', res.id);
      feature.set('type', res.type);
      feature.set('fromTool', 'annotation');
      feature.set('visible', true);
      feature.set('data', res);
      feature.set('color', res.annotation_color);
      feature.set('visible1', true);
      this.sideNavService.closeRightSideNav();
      setTimeout(() => {
        const source = this.layer.getSource();
        const features = source.getFeatures();
        for (let i = 0; i < features.length; i++) {
          if (
            features[i].get('type') == 'point' &&
            features[i].get('type') == type &&
            features[i].get('visible') == true
          ) {
            features[i].setStyle(this.pointStyle(features[i].get('color')));
          } else if (
            features[i].get('type') == 'line' &&
            features[i].get('type') == type &&
            features[i].get('visible') == true
          ) {
            features[i].setStyle(this.lineStyle(features[i].get('color')));
          } else if (
            features[i].get('type') == 'polygon' &&
            features[i].get('type') == type &&
            features[i].get('visible') == true
          ) {
            features[i].setStyle(this.polygonStyle(features[i].get('color')));
          } else if (
            features[i].get('type') == 'geomcollection' &&
            features[i].get('type') == type &&
            features[i].get('visible') == true
          ) {
            features[i].setStyle(
              this.geomcollectionStyle(features[i].get('color'))
            );
          }
        }
        //color modify for newly created annotation

        if (res.type == 'point') {
          feature.setStyle(this.pointStyle(res.annotation_color));
          feature.set('visible1', true);
          feature.set('visible', true);
        } else if (type == 'line') {
          feature.setStyle(this.lineStyle(res.annotation_color));
          feature.set('visible1', true);
          feature.set('visible', true);
        } else if (type == 'polygon') {
          feature.setStyle(this.polygonStyle(res.annotation_color));
          feature.set('visible1', true);
          feature.set('visible', true);
        } else if (type == 'geomcollection') {
          feature.setStyle(this.geomcollectionStyle(res.annotation_color));
          feature.set('visible1', true);
          feature.set('visible', true);
        }
        //prevent zoom on creating new annotation
        // this.mapService.mapLayer
        //   .getView()
        //   .setCenter(getCenter(feature.getGeometry().getExtent()));
        // this.mapService.mapLayer
        //   .getView()
        //   .fit(feature.getGeometry().getExtent(), { maxZoom: 19 });
        this.layer.getSource().addFeatures([feature]);
        this.checKAllValues(type);
        this.mapService.preSelectedAnnotation = '';
        this.setShareAnnotation();
      }, 10);
      this.active = [];
      this.previousNum = null;
      this.previousId = null;
      this.mapService.getdrawEnable(false);
    }
    this.previousNum = null;
    this.previousId = null;
  }

  //set state for annotation panels
  setState() {
    this.sideNavService.annotComponentState = {
      exapandPanel1: this.panelOpenState1,
      exapandPanel2: this.panelOpenState2,
      exapandPanel3: this.panelOpenState3,
      exapandPanel4: this.panelOpenState4,
    };

    this.setShareAnnotation();
  }

  setDynamicState(i: any, folderId: any = null) {
    if (folderId) {
      this.sideNavService.annotFolderState[`exapandPanelId${folderId}`] =
        this.panelOpenState[i];
    } else {
      this.sideNavService.annotFolderState[`exapandPanelParent`] =
        this.panelOpenState[`exapandPanelParent`];
    }

    this.setShareAnnotationForFolder();
  }

  setShareAnnotation() {
    this.mapService.annotationShare = [];
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('visible1') == true &&
        features[i].get('visible') == true
      ) {
        this.mapService.annotationShare.push(features[i].get('id'));
      }
    }
  }

  setShareAnnotationForFolder() {
    this.mapService.annotationFolderShare = [];
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('visible') == true &&
        features[i].get('subType') == 'folder' &&
        features[i].get('visible1') == true
      ) {
        this.mapService.annotationFolderShare.push(features[i].get('id'));
      } else {
        const index = this.mapService.annotationShare.indexOf(
          features[i].get('id')
        );
        if (index != -1) {
          this.mapService.annotationShare.splice(index, 1);
        }
      }
    }

    this.mapService.annotationShare = this.mapService.annotationShare.concat(
      this.mapService.annotationFolderShare
    );
    this.mapService.annotationShare = this.mapService.annotationShare.filter(
      (v: any, i: any, a: any) => a.indexOf(v) === i
    );
  }

  //check annotation panels open or closed
  checkedList(type: any): void {
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (features[i].get('type') == type) {
        if (type == 'point') {
          this.sideNavService.legendAnnotCheck.checked1 = true;
          features[i].setStyle(this.pointStyle(features[i].get('color')));
          features[i].set('visible1', true);
          features[i].set('visible', true);
        } else if (type == 'line') {
          this.sideNavService.legendAnnotCheck.checked2 = true;
          features[i].setStyle(this.lineStyle(features[i].get('color')));
          features[i].set('visible1', true);
          features[i].set('visible', true);
        } else if (type == 'polygon') {
          this.sideNavService.legendAnnotCheck.checked3 = true;
          features[i].setStyle(this.polygonStyle(features[i].get('color')));
          features[i].set('visible1', true);
          features[i].set('visible', true);
        } else if (type == 'geomcollection') {
          features[i].setStyle(
            this.geomcollectionStyle(features[i].get('color'))
          );
          features[i].set('visible1', true);
          features[i].set('visible', true);
        }
      }
    }

    for (let i = 0; i < this.sideNavService.annotationData.length; i++) {
      if (this.sideNavService.annotationData[i].type == type) {
        this.sideNavService.annotationData[i].visible = true;
      }
    }

    this.checKAllValues(type);
    this.setState();
  }

  //check annotation panels open or closed
  checkedListFolder(name: any): void {
    for (let i = 0; i < this.sideNavService.folderData.length; i++) {
      for (let j = 0; j < this.sideNavService.folderData[i].length; j++) {
        if (this.sideNavService.folderData[i].annotationData[j].name == name) {
          this.sideNavService.folderData[i].annotationData[j].visible = true;
        }
      }
    }
  }

  //advanced select api hit function
  getAdvanceSelect() {
    //check for hidding data panel and then show
    if (this.sideNavService.hideRightPanelForImage) {
      this.sideNavService.closeRightSideNav();
      this.sideNavService.showAnimateNow = false;
      this.sideNavService.hideRightPanelForImage = false;
    }
    this.sideNavService.fromAnnotation = true;
    this.sideNavService.fromAnnotationFeature = true;
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.mapService.pointGeometry = this.pointGeometry;
    this.mapService.polygonGeometry = this.wkt;
    this.mapService.perviousLabel = '0';
    this.globalService.toggleLoader(true);
    this.mapService
      .getSearchCoordinates(
        this.mapId,
        this.mapService.getLayersId(),
        this.mapService.polygonGeometry,
        this.mapService.pointGeometry,
        this.parcelLength,
        this.slectedUnion,
        this.ctrlCheck,
        this.polygonAnnotation,
        this.linesAnnotation,
        this.pointSAnnotation,
        this.mapService.mapLayer.getView().getResolution().toString(),
        this.selectedFeature,
        this.pre_select_id,
        '',
        ''
      )
      .subscribe((res) => {
        this.mapService.innerBuffer = []

        if (res.features.length) {
          this.mapService.perviousLabel =
            res.features[res.features.length - 1].label.toString();
        }

        this.selectedFeatures = res.features;
        const highestLabel = this.selectedFeatures.reduce((prevObj: any, currentObj: any) => {
          return (prevObj.label > currentObj.label) ? prevObj : currentObj;
        }).label;
        this.mapService.perviousLabel = highestLabel
        const fields: any = {};
        if (this.selectedFeatures.length > 1) {
          for (let i = 0; i < this.selectedFeatures.length; i++) {
            this.mapService.innerBuffer.push(this.selectedFeatures[i].geom_wkt)
            this.mapService.multiParcelId.push(this.selectedFeatures[i].id);
            if (fields[this.selectedFeatures[i].layer_id]) {
              fields[this.selectedFeatures[i].layer_id.toString()].push(
                this.selectedFeatures[i].id.toString()
              );
            } else {
              fields[this.selectedFeatures[i].layer_id] = [];
              fields[this.selectedFeatures[i].layer_id.toString()].push(
                this.selectedFeatures[i].id.toString()
              );
            }
            this.mapService.parcel = JSON.stringify(fields);
            this.mapService.featureLayersId.push(
              this.selectedFeatures[i].layer_id
            );
            this.mapService.featureLayerId = [
              ...new Set(this.mapService.featureLayersId),
            ].toString();
          }
        } else {
          this.mapService.innerBuffer = []
          for (let i = 0; i < this.selectedFeatures.length; i++) {
            this.mapService.innerBuffer.push(this.selectedFeatures[i].geom_wkt)
            this.mapService.multiParcelId.push(this.selectedFeatures[i].id);
            // multiParcel
            this.mapService.multiParcel = false;
            // parcel ID
            this.mapService.parcels.push(this.selectedFeatures[i].id);
            this.mapService.parcel = [
              ...new Set(this.mapService.parcels),
            ].toString();
            // Feature Layer Id
            this.mapService.featureLayersId.push(
              this.selectedFeatures[i].layer_id
            );
            this.mapService.featureLayerId = [
              ...new Set(this.mapService.featureLayersId),
            ].toString();
          }
        }
        this.sideNavService.decideComponent(res);
      });
  }

  //check if annotation panels are showing data or not from legend
  checkUncheckBasedOnLegend(type: any) {
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (features[i].get('type') == type) {
        features[i].setStyle(new Style({}));
      }
    }
    if (!this.annotationData) {
      this.annotationData = this.sideNavService.annotationData;
    }
    for (let i = 0; i < this.annotationData.length; i++) {
      if (this.annotationData[i].type == type) {
        this.annotationData[i].visible = false;
      }
    }
    if (type == 'point') {
      this.sideNavService.legendAnnotCheck.checked1 = false;
      // alert("check")
    } else if (type == 'line') {
      this.sideNavService.legendAnnotCheck.checked2 = false;
    } else if (type == 'polygon') {
      this.sideNavService.legendAnnotCheck.checked3 = false;
    }
  }

  //show annotation from legend
  showAnnotFromLegend(type: any): void {
    this.mapService.mapLayer.removeInteraction(this.drawShape);
    this.panelOpenState1 = true;
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (features[i].get('type') == type) {
        features[i].setStyle(this.pointStyle(features[i].get('color')));

        features[i].set('visible', true);
        features[i].set('visible1', true);
      }
    }
    //

    if (!this.annotationData) {
      this.annotationData = this.sideNavService.annotationData;
    }
    for (let i = 0; i < this.annotationData.length; i++) {
      if (this.annotationData[i].type == type) {
        this.annotationData[i].visible = true;
      }
    }
    if (type == 'point') {
      this.openPanel1();
    } else if (type == 'line') {
      this.openPanel2();
    }
    if (type == 'polygon') {
      this.openPanel3();
    }
    this.setShareAnnotation();
  }

  //hiding annotation from legend
  hideAnnotFromLegend(type: any): void {
    this.mapService.mapLayer.removeInteraction(this.drawShape);
    this.panelOpenState1 = true;
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('type') == type &&
        features[i].get('visible') == true
      ) {
        features[i].setStyle(new Style({}));
        features[i].set('visible', false);
        features[i].set('visible1', false);
      }
    }
    this.setShareAnnotation();
  }

  //check values for legend annotation for certatin type
  checKAllValues(type: any): void {
    let decide: any = false;
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('type') == type &&
        features[i].get('visible1') == true
      ) {
        decide = true;
        break;
      } else if (
        features[i].get('type') == type &&
        features[i].get('visible1') == false
      ) {
        decide = false;
      }
    }

    if (decide == true && type == 'point') {
      this.sideNavService.legendAnnotCheck.checked1 = true;
    } else if (decide == false && type == 'point') {
      this.sideNavService.legendAnnotCheck.checked1 = false;
    }
    if (decide == true && type == 'line') {
      this.sideNavService.legendAnnotCheck.checked2 = true;
    } else if (decide == false && type == 'line') {
      this.sideNavService.legendAnnotCheck.checked2 = false;
    }
    if (decide == true && type == 'polygon') {
      this.sideNavService.legendAnnotCheck.checked3 = true;
    } else if (decide == false && type == 'polygon') {
      this.sideNavService.legendAnnotCheck.checked3 = false;
    }
  }

  //destroy interaction and close right panel if open for new feature creation
  ngOnDestroy(): void {
    this.mapService.getdrawEnable(false);
    const source = this.drawLayer?.getSource();
    const features = source?.getFeatures();
    if (features?.length) {
      features.forEach((feature: any) => {
        source.removeFeature(feature);
      });
      this.sideNavService.newAnnoCreated = false;
      //clear feature list
      this.sideNavService.activeFeatureList = [];
      if (this.mapService.result) {
        this.mapService.result.getSource().clear();
        this.sideNavService.saveFeatureListData = [];
      }
      this.sideNavService.closeRightSideNav();
      this.sideNavService.sideNavState('close');
      //clear feature Name
      if (this.sideNavService.feature) {
        this.sideNavService.feature.setStyle(new Style({}));
      }
      if (this.sideNavService.feature1) {
        this.sideNavService.feature1.setStyle(new Style({}));
      }
      const polystyle2 = new Style({
        fill: new Fill({
          color: 'rgb(255, 204, 51,0.3)',
        }),
        stroke: new Stroke({
          color: '#ffcc33',
          width: 2,
        }),
      });
      for (let i = 0; i < this.mapService.selectedParcels.length; i++) {
        if (
          this.mapService.selectedParcels[i].get('number') ==
          this.sideNavService.featureNameDataforAnnot?.id &&
          !this.sideNavService.fromAnnotation
        ) {
          this.sideNavService.fromAnnotation = false;
          this.mapService.selectedParcels[i].setStyle(polystyle2);
          // break;
        }
      }
    } else {
      this.sideNavService.newAnnoCreated = true;
    }
    this.mapService.mapLayer.removeInteraction(this.drawShape);
  }

  //activate class
  activateClass(
    dataId: any,
    index: number,
    data: any,
    event: any,
    folderId: any = null,
    fromFolder: any = null
  ) {
    this.clicked = [];
    if (!event.ctrlKey) {
      this.deleteArray = [];
      this.singleValue = [dataId];
      this.clearAllSelectionsForDelete();
      this.preSelected = true;
      this.selectedIndexId = dataId;
      this.selectedIndex = index;
      this.zoomNow = false;
      this.sideNavService.setFeatureNameView = true;
      if (!fromFolder) {
        this.zoomClicked(dataId, index, data);
      } else {
        this.zoomClickedForFolder(dataId, index, data, folderId);
      }
    } else {
      this.singleValue = [];
      if (this.preSelected) {
        if (index != this.selectedIndex) {
          const index2 = this.deleteArray.indexOf(this.selectedIndexId);
          if (index2 === -1) {
            this.deleteArray.push(this.selectedIndexId);
            const anno = document.getElementById(
              `anno-${this.selectedIndex}`
            ) as HTMLElement;
            anno.style.backgroundColor = '#e5f0f9';
            if (this.deleteArray.length > 0) {
              this.showDeleteButton = true;
            }
            this.preSelected = false;
            this.selectedIndex = -1;
          }
        }
      }

      const index1 = this.deleteArray.indexOf(dataId);
      this.zoomNow = true;
      this.multiple = true;
      if (index1 === -1) {
        this.deleteArray.push(dataId);
        const anno = document.getElementById(`anno-${index}`) as HTMLElement;
        anno.style.backgroundColor = '#e5f0f9';
        if (this.deleteArray.length > 0) {
          this.showDeleteButton = true;
        }
      } else {
        this.deleteArray.splice(index1, 1);
        const anno = document.getElementById(`anno-${index}`) as HTMLElement;
        anno.style.backgroundColor = 'white';
        if (this.deleteArray.length == 0) {
          this.showDeleteButton = false;
        }
      }
    }

    if (this.deleteArray.length > 1) {
      this.multiple = true;
    } else {
      this.multiple = false;
    }
  }

  clearAllSelectionsForDelete(): void {
    for (let i = 0; i < i + 1; i++) {
      const anno: any = document.getElementById(`anno-${i}`) as HTMLElement;
      if (anno) {
        anno.style.backgroundColor = 'white';
      } else {
        break;
      }
    }

    for (let k = 0; k < this.sideNavService.folderData.length; k++) {
      for (
        let i = 0;
        i < this.sideNavService.folderData[k].annotation.length;
        i++
      ) {
        const anno: any = document.getElementById(
          `anno-${i +
          this.sideNavService.annotationData.length *
          this.sideNavService.folderData[k].annotation[i].id
          }`
        ) as HTMLElement;

        if (anno) {
          anno.style.backgroundColor = 'white';
        } else {
          break;
        }
      }
    }
  }

  //select annotation id from mouse click
  selectFromMouse(id: any): void {
    for (let i = 0; i < this.sideNavService.annotationData.length; i++) {
      if (this.sideNavService.annotationData[i].id == id) {
        this.selectedIndex = i;
      }
    }
  }

  selectFromMouseFolder(id: any, folderId: any): void {
    for (let i = 0; i < this.sideNavService.folderData.length; i++) {
      if (this.sideNavService.folderData[i].id == folderId) {
        for (
          let j = 0;
          j < this.sideNavService.folderData[i].annotation.length;
          j++
        ) {
          if (this.sideNavService.folderData[i].annotation[j].id == id) {
            this.selectedIndex = i;
          }
        }
      }
    }
  }
  closePanel() {
    this.mapService.mapLayer.removeInteraction(this.drawShape);
    this.mapService.getdrawEnable(false);
    this.mapService.setClosePanel(true);
    this.mapService.closePanel = true;
  }
  clearBox(): void {
    this.clicked = [];
  }

  //for setting submenu position relative to its parents div and top accordingly
  getPosition(i: any) {
    this.createFolder = false;
    this.editFolderModal = false;
    this.clickedFolder = [];
    this.previousFolderId = null;
    if (this.clicked[i]) {
      const element: any = document.getElementById(`anno-${i}`) as HTMLElement;

      const element1 = document.getElementById(`subMenu${i}`) as HTMLElement;
      if (element) {
        let topPos = element.getBoundingClientRect().top + window.scrollY;
        if (window.innerHeight - topPos < 110) {
          topPos = topPos - 130;
          element1.style.top = `${topPos.toString()}px`;
        } else {
          element1.style.top = `${topPos.toString()}px`;
        }
      }
    }
  }

  activityLoging(state: any) {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapService.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: state,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
  activityLogingWkt(state: any, geom: any) {
    if (!geom) {
      geom = '';
    }
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapService.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: state,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          wkt: geom,
          point: '',
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            // console.log('a');
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
  checkHtmlEntity = (str: any) => {
    return /^(?:&nbsp;)+$/.test(str);
  };

  openCreateFolderMenu(): any {
    this.folder = {
      name: '',
      description: '',
    };
    this.createFolder = true;
    setTimeout(() => {
      if (this.createFolder) {
        const element: any = document.getElementById(
          'folder_icon'
        ) as HTMLElement;

        const element1 = document.getElementById('folder_menu') as HTMLElement;
        if (element) {
          let topPos = element.getBoundingClientRect().top + window.scrollY;
          if (window.innerHeight - topPos < 100) {
            topPos = topPos - 50;
            element1.style.top = `${topPos.toString()}px`;
          } else {
            element1.style.top = `${topPos.toString()}px`;
          }
        }
      }
    }, 1);
  }

  openFolder(i: any, folderId: any) {
    this.panelOpenState[i] = true;
    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('subType') == 'folder' &&
          folderId == features[i].get('folderId') &&
          features[i].get('visible') == true
        ) {
          if (features[i].get('type1') == 'point') {
            features[i].setStyle(this.pointStyle(features[i].get('color')));
            features[i].set('visible1', true);
          } else if (features[i].get('type1') == 'line') {
            features[i].setStyle(this.lineStyle(features[i].get('color')));
            features[i].set('visible1', true);
          } else if (features[i].get('type1') == 'polygon') {
            features[i].setStyle(this.polygonStyle(features[i].get('color')));
            features[i].set('visible1', true);
          } else if (features[i].get('type1') == 'geomcollection') {
            features[i].setStyle(
              this.geomcollectionStyle(features[i].get('color'))
            );
            features[i].set('visible1', true);
          }
        }
      }

      // this.activityLog('Folder:On', '');
      this.setDynamicState(i, folderId);
    }
  }

  closeFolder(i: any, folderId: any) {
    this.panelOpenState[i] = false;

    if (this.layer) {
      const source = this.layer.getSource();
      const features = source.getFeatures();
      for (let i = 0; i < features.length; i++) {
        if (
          features[i].get('subType') == 'folder' &&
          folderId == features[i].get('folderId') &&
          features[i].get('visible') == true
        ) {
          features[i].setStyle(new Style({}));
          features[i].set('visible1', false);
        }
      }

      // this.activityLog('Folder:Off', '');
    }
    this.setDynamicState(i, folderId);
  }
  checkIfFolderAlreadyExist(name: any): any {
    for (let i = 0; i < this.sideNavService.folderData.length; i++) {
      if (name == this.sideNavService.folderData[i].name && name.length !== 0) {
        return true;
      }
    }
    return false;
  }

  saveFolder() {
    this.createFolder = false;
    const namePresent = this.checkIfFolderAlreadyExist(this.folder.name);
    let body: any = {};
    if (!namePresent) {
      body = {
        title: this.folder.name,
        sub_title: this.folder.description,
      };
    } else {
      body = {
        title: this.folder.name + Math.floor(Math.random() * 10),
        sub_title: this.folder.description,
      };
    }
    body.used_for = 'annotation';
    this.loader.toggleSpinner(true);
    this.mapService.createAnnotationFolder(body).subscribe(
      (res) => {
        res.annotation = [];
        this.sideNavService.folderData.push(res);
        this.sideNavService.folderData = this.sortAnnotationData(
          this.sideNavService.folderData,
          'title'
        );
        this.folderData = this.sideNavService.folderData;
        // this.sideNavService.addAnnotationStateHanledKeys(); no need to handled with this func
        this.folder = {
          name: '',
          description: '',
        };
        this.loader.toggleSpinner(false);
      },
      () => {
        this.loader.toggleSpinner(false);
      }
    );
    this.setShareAnnotationForFolder();
  }

  cancelFolder() {
    this.createFolder = false;
    this.editFolderModal = false;
  }

  showFolderMainMenu(index: any) {
    this.clickedFolder = [];

    if (this.previousFolderId == index) {
      this.clickedFolder[index] = false;
      this.previousFolderId = null;
    } else {
      this.clickedFolder[index] = true;
      this.previousFolderId = index;
    }
    this.setShareAnnotationForFolder();
  }

  deleteFolder(id: any, index: any) {
    this.dialog.open(DeleteModalComponent, {
      data: {
        type: 'folder_annotation_delete',
        id: id,
      },
    });
    const element: any = document.getElementById(
      `editFolder${index}`
    ) as HTMLElement;

    const element1 = document.getElementById(
      `delete_modal_folder_position`
    ) as HTMLElement;
    if (element) {
      let topPos = element.getBoundingClientRect().top + window.scrollY;
      if (window.innerHeight - topPos < 100) {
        topPos = topPos - 20;
        element1.style.top = `${topPos.toString()}px`;
        element1.style.left = '305px';
      } else {
        topPos = topPos + 20;
        element1.style.top = `${topPos.toString()}px`;
        element1.style.left = '305px';
      }
    }
    this.setShareAnnotationForFolder();
  }

  updateFolder(id: any, name: any, description: any, index: any) {
    const element: any = document.getElementById(
      `editFolder${index}`
    ) as HTMLElement;

    const element1 = document.getElementById(`folder_menu`) as HTMLElement;
    if (element) {
      let topPos = element.getBoundingClientRect().top + window.scrollY;
      if (window.innerHeight - topPos < 100) {
        topPos = topPos - 50;
        element1.style.top = `${topPos.toString()}px`;
      } else {
        topPos = topPos - 10;
        element1.style.top = `${topPos.toString()}px`;
      }
    }

    this.editFolderModal = true;
    this.clickedFolder = [];
    this.folder = {
      name: name,
      description: description,
      id: id,
    };
    this.setShareAnnotationForFolder();
  }

  editFolder() {
    const body: any = {
      title: this.folder.name,
      sub_title: this.folder.description,
    };
    this.loader.toggleSpinner(true);
    this.mapService.editAnnotationFolder(body, this.folder.id).subscribe(
      (res) => {
        for (let i = 0; i < this.sideNavService.folderData.length; i++) {
          if (this.sideNavService.folderData[i].id == res.id) {
            this.sideNavService.folderData[i].title = res.title;
            this.sideNavService.folderData[i].sub_title = res.sub_title;
            this.sideNavService.folderData = this.sortAnnotationData(
              this.sideNavService.folderData,
              'title'
            );
            this.folderData = this.sideNavService.folderData;
            break;
          }
        }

        this.folder = {
          name: res.title,
          description: res.sub_title,
        };
        this.editFolderModal = false;
        this.createFolder = false;
        this.loader.toggleSpinner(false);
      },
      () => {
        this.editFolderModal = false;
        this.createFolder = false;
        this.loader.toggleSpinner(false);
      }
    );
    this.setShareAnnotationForFolder();
  }

  getPositionFolderExpansionMenu(i: any) {
    setTimeout(() => {
      if (this.clickedFolder[i]) {
        const element: any = document.getElementById(
          `showFolderExpansionMenu${i}`
        ) as HTMLElement;

        const element1 = document.getElementById(
          `FolderExpansionMenu${i}`
        ) as HTMLElement;
        if (element) {
          let topPos = element.getBoundingClientRect().top + window.scrollY;
          if (window.innerHeight - topPos < 100) {
            topPos = topPos - 50;
            element1.style.top = `${topPos.toString()}px`;
          } else {
            topPos = topPos - 10;
            element1.style.top = `${topPos.toString()}px`;
          }
        }
      }
    }, 1);
  }

  showAvailableFolders(): void {
    this.availableFolder = true;
  }

  hideAvailableFolders(): void {
    this.availableFolder = false;
  }

  moveBackTofolderless(
    folderId: any,
    currentFolderId: any,
    annotationId: any
  ): void {
    this.multiple = false;
    if (this.deleteArray.length == 0) {
      this.deleteArray.push(annotationId);
    }

    const body: any = {
      annotation_ids: this.deleteArray,
      folder_id: folderId,
    };
    this.loader.toggleSpinner(true);
    this.mapService.moveAnnotationToFolder(body).subscribe(
      () => {
        //removing features from folder
        const source = this.layer.getSource();
        let features = source.getFeatures();
        for (let j = 0; j < this.deleteArray.length; j++) {
          for (let i = 0; i < features.length; i++) {
            if (
              features[i].get('id') == this.deleteArray[j] &&
              features[i].get('subType') == 'folder'
            ) {
              features[i].setStyle(new Style({}));
              features[i].set('visible', false);
              source.removeFeature(features[i]);
            }
          }
        }

        //removing data from folder
        const mergeAnnotation: any = [];
        for (let i = 0; i < this.sideNavService.folderData.length; i++) {
          // remove this check
          // if (this.sideNavService.folderData[i].id == currentFolderId) {
          for (let j = 0; j < this.deleteArray.length; j++) {
            for (
              let k = 0;
              k < this.sideNavService.folderData[i].annotation.length;
              k++
            ) {
              if (
                this.sideNavService.folderData[i].annotation[k].id ==
                this.deleteArray[j]
              ) {
                mergeAnnotation.push(
                  this.sideNavService.folderData[i].annotation[k]
                );
                this.sideNavService.folderData[i].annotation.splice(k, 1);
                this.folderData = this.sideNavService.folderData;
              }
            }
          }
          // }
        }

        //moving data to folderless and add feature to folderless
        for (let k = 0; k < mergeAnnotation.length; k++) {
          this.sideNavService.annotationData.push(mergeAnnotation[k]);
          this.annotationData = this.sideNavService.annotationData;
          const f =
            this.annotationData[this.sideNavService.annotationData.length - 1];
          const type = f.type;
          const format = new WKT();
          features = format.readFeature(f[type]);
          features.set(
            'id',
            this.annotationData[this.sideNavService.annotationData.length - 1]
              .id
          );
          features.set(
            'data',
            this.annotationData[this.sideNavService.annotationData.length - 1]
          );
          features.set(
            'type',
            this.annotationData[this.sideNavService.annotationData.length - 1]
              .type
          );
          features.set(
            'color',
            this.annotationData[this.sideNavService.annotationData.length - 1]
              .annotation_color
          );
          features.set('fromTool', 'annotation');
          features.set('visible', true);
          const style = new Style({});
          features.setStyle(style);
          source.addFeatures([features]);
          this.mapService.annotationFeature = source;
        }
        this.sideNavService.annotationData = this.sortAnnotationData(
          this.sideNavService.annotationData,
          'name'
        );
        this.annotationData = this.sideNavService.annotationData;
        this.sideNavService.folderData = this.sortAnnotationData(
          this.sideNavService.folderData,
          'title'
        );
        this.folderData = this.sideNavService.folderData;
        this.deleteArray = [];
        this.setShareAnnotationForFolder();
        this.sideNavService.closeRightSideNav();
        this.loader.toggleSpinner(false);
      },
      () => {
        this.loader.toggleSpinner(false);
      }
    );
  }

  moveToFolder(annotationId: any, folderId: any): void {
    this.multiple = false;
    if (this.deleteArray.length == 0) {
      this.deleteArray.push(annotationId);
    }
    const body: any = {
      annotation_ids: this.deleteArray,
      folder_id: folderId,
    };
    this.loader.toggleSpinner(true);
    this.mapService.moveAnnotationToFolder(body).subscribe(
      () => {
        //remove feature from folderless
        const source = this.layer.getSource();
        let features = source.getFeatures();
        for (let j = 0; j < this.deleteArray.length; j++) {
          for (let i = 0; i < features.length; i++) {
            if (features[i].get('id') == this.deleteArray[j]) {
              features[i].setStyle(new Style({}));
              features[i].set('visible', false);
              source.removeFeature(features[i]);
            }
          }
        }
        //removing data from folderless
        const mergeAnnotation: any = [];
        for (let j = 0; j < this.deleteArray.length; j++) {
          for (let i = 0; i < this.sideNavService.annotationData.length; i++) {
            if (
              this.sideNavService.annotationData[i].id == this.deleteArray[j]
            ) {
              mergeAnnotation.push(this.sideNavService.annotationData[i]);
              this.sideNavService.annotationData.splice(i, 1);
              this.annotationData = this.sideNavService.annotationData;
              break;
            }
          }
        }

        // check if to remove data from another folder too
        //removing features from folder

        for (let j = 0; j < this.deleteArray.length; j++) {
          for (let i = 0; i < features.length; i++) {
            if (
              features[i].get('id') == this.deleteArray[j] &&
              features[i].get('subType') == 'folder'
            ) {
              features[i].setStyle(new Style({}));
              features[i].set('visible', false);
              source.removeFeature(features[i]);
            }
          }
        }

        for (let i = 0; i < this.sideNavService.folderData.length; i++) {
          // remove this check
          // if (this.sideNavService.folderData[i].id == currentFolderId) {
          for (let j = 0; j < this.deleteArray.length; j++) {
            for (
              let k = 0;
              k < this.sideNavService.folderData[i].annotation.length;
              k++
            ) {
              if (
                this.sideNavService.folderData[i].annotation[k].id ==
                this.deleteArray[j]
              ) {
                mergeAnnotation.push(
                  this.sideNavService.folderData[i].annotation[k]
                );
                this.sideNavService.folderData[i].annotation.splice(k, 1);
                this.folderData = this.sideNavService.folderData;
              }
            }
          }
          // }
        }

        //moving data and features to folder
        for (let i = 0; i < this.sideNavService.folderData.length; i++) {
          if (this.sideNavService.folderData[i].id == folderId) {
            for (let k = 0; k < mergeAnnotation.length; k++) {
              this.sideNavService.folderData[i].annotation.push(
                mergeAnnotation[k]
              );
              this.folderData = this.sideNavService.folderData;
              this.sideNavService.folderData[i].annotation[
                this.sideNavService.folderData[i].annotation.length - 1
              ].visible = true;
              const f =
                this.sideNavService.folderData[i].annotation[
                this.sideNavService.folderData[i].annotation.length - 1
                ];
              const type = f.type;
              const format = new WKT();
              features = format.readFeature(f[type]);
              features.set(
                'id',
                this.sideNavService.folderData[i].annotation[
                  this.sideNavService.folderData[i].annotation.length - 1
                ].id
              );
              features.set(
                'color',
                this.sideNavService.folderData[i].annotation[
                  this.sideNavService.folderData[i].annotation.length - 1
                ].annotation_color
              );
              features.set(
                'data',
                this.sideNavService.folderData[i].annotation[
                this.sideNavService.folderData[i].annotation.length - 1
                ]
              );
              features.set(
                'type1',
                this.sideNavService.folderData[i].annotation[
                  this.sideNavService.folderData[i].annotation.length - 1
                ].type
              );
              features.set('subType', 'folder');

              features.set('folderId', this.sideNavService.folderData[i].id);
              features.set('fromTool', 'annotation');
              features.set('visible', true);
              const style = new Style({});
              features.setStyle(style);
              source.addFeatures([features]);
              this.mapService.annotationFeature = source;
            }
            break;
          }
        }
        this.sideNavService.annotationData = this.sortAnnotationData(
          this.sideNavService.annotationData,
          'name'
        );
        this.annotationData = this.sideNavService.annotationData;
        this.sideNavService.folderData = this.sortAnnotationData(
          this.sideNavService.folderData,
          'title'
        );
        this.folderData = this.sideNavService.folderData;
        this.setShareAnnotationForFolder();
        this.deleteArray = [];
        this.sideNavService.closeRightSideNav();

        this.loader.toggleSpinner(false);
      },
      () => {
        this.loader.toggleSpinner(false);
      }
    );
  }

  moveToAnotherFolder(
    currentFolderId: any,
    movingFolderId: any,
    annotationId: any
  ): void {
    this.multiple = false;
    if (this.deleteArray.length == 0) {
      this.deleteArray.push(annotationId);
    }
    const body: any = {
      annotation_ids: this.deleteArray,
      folder_id: movingFolderId,
    };
    this.loader.toggleSpinner(true);
    this.mapService.moveAnnotationToFolder(body).subscribe(
      () => {
        const source = this.layer.getSource();
        let features = source.getFeatures();

        //removing data and features from current folder

        for (let i = 0; i < features.length; i++) {
          for (let j = 0; j < this.deleteArray.length; j++) {
            if (
              features[i].get('id') == this.deleteArray[j] &&
              features[i].get('subType') == 'folder'
            ) {
              features[i].setStyle(new Style({}));
              features[i].set('visible', false);
              source.removeFeature(features[i]);
            }
          }
        }
        const mergeAnnotation: any = [];
        for (let l = 0; l < this.deleteArray.length; l++) {
          for (let i = 0; i < this.sideNavService.folderData.length; i++) {
            // removing this check
            // if (this.sideNavService.folderData[i].id == currentFolderId) {
            for (
              let j = 0;
              j < this.sideNavService.folderData[i].annotation.length;
              j++
            ) {
              if (
                this.sideNavService.folderData[i].annotation[j].id ==
                this.deleteArray[l]
              ) {
                mergeAnnotation.push(
                  this.sideNavService.folderData[i].annotation[j]
                );
                this.sideNavService.folderData[i].annotation.splice(j, 1);
                this.folderData = this.sideNavService.folderData;
              }
            }
            // }
          }
        }

        //remove feature from folderless if any

        for (let j = 0; j < this.deleteArray.length; j++) {
          for (let i = 0; i < features.length; i++) {
            if (features[i].get('id') == this.deleteArray[j]) {
              features[i].setStyle(new Style({}));
              features[i].set('visible', false);
              source.removeFeature(features[i]);
            }
          }
        }
        //removing data from folderless

        for (let j = 0; j < this.deleteArray.length; j++) {
          for (let i = 0; i < this.sideNavService.annotationData.length; i++) {
            if (
              this.sideNavService.annotationData[i].id == this.deleteArray[j]
            ) {
              mergeAnnotation.push(this.sideNavService.annotationData[i]);
              this.sideNavService.annotationData.splice(i, 1);
              this.annotationData = this.sideNavService.annotationData;
              break;
            }
          }
        }

        //moving data and feature to another folder
        for (let i = 0; i < this.sideNavService.folderData.length; i++) {
          if (this.sideNavService.folderData[i].id == movingFolderId) {
            for (let k = 0; k < mergeAnnotation.length; k++) {
              this.sideNavService.folderData[i].annotation.push(
                mergeAnnotation[k]
              );

              this.folderData = this.sideNavService.folderData;
              this.sideNavService.folderData[i].annotation[
                this.sideNavService.folderData[i].annotation.length - 1
              ].visible = true;
              const f =
                this.sideNavService.folderData[i].annotation[
                this.sideNavService.folderData[i].annotation.length - 1
                ];
              const type = f.type;
              const format = new WKT();
              features = format.readFeature(f[type]);
              features.set(
                'id',
                this.sideNavService.folderData[i].annotation[
                  this.sideNavService.folderData[i].annotation.length - 1
                ].id
              );
              features.set(
                'data',
                this.sideNavService.folderData[i].annotation[
                this.sideNavService.folderData[i].annotation.length - 1
                ]
              );
              features.set(
                'color',
                this.sideNavService.folderData[i].annotation[
                  this.sideNavService.folderData[i].annotation.length - 1
                ].annotation_color
              );
              features.set(
                'type1',
                this.sideNavService.folderData[i].annotation[
                  this.sideNavService.folderData[i].annotation.length - 1
                ].type
              );
              features.set('subType', 'folder');
              features.set('folderId', this.sideNavService.folderData[i].id);
              features.set('fromTool', 'annotation');
              features.set('visible', true);
              const style = new Style({});
              features.setStyle(style);
              source.addFeatures([features]);
              this.mapService.annotationFeature = source;
              this.sideNavService.folderData = this.sortAnnotationData(
                this.sideNavService.folderData,
                'title'
              );
              this.folderData = this.sideNavService.folderData;
            }
          }
        }
        this.sideNavService.annotationData = this.sortAnnotationData(
          this.sideNavService.annotationData,
          'name'
        );
        this.annotationData = this.sideNavService.annotationData;
        this.sideNavService.folderData = this.sortAnnotationData(
          this.sideNavService.folderData,
          'title'
        );
        this.folderData = this.sideNavService.folderData;
        this.deleteArray = [];
        this.setShareAnnotationForFolder();
        this.sideNavService.closeRightSideNav();
        this.loader.toggleSpinner(false);
      },
      () => {
        this.loader.toggleSpinner(false);
      }
    );
  }

  openParentFolder(): void {
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('subType') == 'folder' &&
        features[i].get('visible1') == true
      ) {
        if (features[i].get('type1') == 'point') {
          features[i].set('visible', true);
          features[i].setStyle(this.pointStyle(features[i].get('color')));
        } else if (features[i].get('type1') == 'line') {
          features[i].set('visible', true);
          features[i].setStyle(this.lineStyle(features[i].get('color')));
        } else if (features[i].get('type1') == 'polygon') {
          features[i].set('visible', true);
          features[i].setStyle(this.polygonStyle(features[i].get('color')));
        } else if (features[i].get('type1') == 'geomcollection') {
          features[i].set('visible', true);
          features[i].setStyle(
            this.geomcollectionStyle(features[i].get('color'))
          );
        }
      }
    }
    this.panelOpenState[`exapandPanelParent`] = true;
    this.setDynamicState(this.sideNavService.folderData?.length);
  }

  closeParentFolder(): void {
    const source = this.layer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].get('subType') == 'folder' &&
        features[i].get('visible1') == true
      ) {
        features[i].set('visible', false);
        features[i].setStyle(new Style({}));
      }
    }

    this.panelOpenState[`exapandPanelParent`] = false;
    this.setDynamicState(this.sideNavService.folderData?.length);
  }

  onChangeColor(): void {
    //custom style for mini circle when drawing interaction enable and color change
    this.mapService.selectedColor = this.selectedColor;
    this.mapService.mapLayer
      .getInteractions()
      .forEach((interaction: Interaction) => {
        if (interaction instanceof Draw) {
          this.previousSelection = null;
          if (this.active[1]) {
            this.drawShapes('Point', 1);
          } else if (this.active[2]) {
            this.drawShapes('LineString', 2);
          } else if (this.active[3]) {
            this.drawShapes('Polygon', 3);
          }
        }
      });
  }
}
